export default "__VITE_ASSET__DxGoV2Fx__"